import { Box } from "@mui/material";
import { toTitleCase } from "common/utils";
import { useRegistryContext } from "context/RegistryContext";
import { useRegistryPatientContext } from "context/RegistryPatientContext";
import { useLocation, useParams, Link } from "react-router-dom";
import { colors } from "styles/colors";

export default function BreadCrumb() {
  const location = useLocation();
  const { registry } = useRegistryContext();
  const { patient } = useRegistryPatientContext();
  const { registryId, patientId } = useParams();

  const HIDDEN_SEGMENTS = ["registries", "patients"];

  const pathSegments = location.pathname.split("/").filter(Boolean);

  // Determine readiness
  const requiresRegistry = pathSegments.includes(registryId as string);
  const requiresPatient = pathSegments.includes(patientId as string);

  const isReady =
    (!requiresRegistry || registry?.name) &&
    (!requiresPatient || patient?.patient_first_name);

  if (!isReady) return <Box sx={{ height: '20px' }} />;

  let accumulatedPath = "";

  const breadcrumbs = pathSegments
    .map((segment) => {
      accumulatedPath += `/${segment}`;

      let label = toTitleCase(segment);

      if (segment === registryId && registry?.name) {
        label = registry.name;
      }

      if (segment === patientId && patient?.patient_first_name) {
        label = patient.patient_first_name;
      }

      return {
        segment,
        path: accumulatedPath,
        label,
      };
    })
    .filter((crumb) => !HIDDEN_SEGMENTS.includes(crumb.segment));

  const visibleBreadcrumbs = breadcrumbs.slice(-3);

  return (
    <div>
      {visibleBreadcrumbs.map((crumb, index) => {
        const isLast = index === visibleBreadcrumbs.length - 1;

        return (
          <span key={crumb.path} style={{ color: colors.secondary, fontSize: 15 }}>
            {isLast ? (
              <span>{crumb.label}</span>
            ) : (
              <Link to={crumb.path} style={{ color: colors.secondary, fontSize: 15 }}>{crumb.label}</Link>
            )}
            {!isLast && " > "}
          </span>
        );
      })}
    </div>
  );
}